module.exports = __webpack_public_path__ + "static/img/small-arrow-right-orange.b78de65b.svg";